import {IQuoteStockItem} from './quoteStockItems';

export const QUOTE_SECTION_ID_PREFIX = 'quote-section-';

export const QUOTE_GRID_BLANK_ROW_ID = 'blank-row';

export const QUOTE_GRID_SECTION_CODE_PREFIX = '__quote_section__';

/**
 * A named section header within a quote compose list.
 */
export interface IQuoteSectionEntry {
  id: string;
  kind: 'section';
  name: string;
}

/**
 * A stock line on a quote compose list.
 */
export interface IQuoteItemEntry {
  item: IQuoteStockItem;
  kind: 'item';
}

/**
 * Ordered row in a quote — section header or stock item.
 */
export type IQuoteComposeEntry = IQuoteSectionEntry | IQuoteItemEntry;

/**
 * Creates a new quote section identifier.
 */
export const createQuoteSectionId = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return `${QUOTE_SECTION_ID_PREFIX}${crypto.randomUUID()}`;
  }
  return `${QUOTE_SECTION_ID_PREFIX}${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
};

/**
 * Returns true when the entry is a section header row.
 */
export const isQuoteSectionEntry = (entry: IQuoteComposeEntry): entry is IQuoteSectionEntry => {
  return entry.kind === 'section';
};

/**
 * Returns true when the entry is a stock item row.
 */
export const isQuoteItemEntry = (entry: IQuoteComposeEntry): entry is IQuoteItemEntry => {
  return entry.kind === 'item';
};
